import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../App";


export default function AuthenticatedRoute({ children }) {
  const { pathname, search } = useLocation();

  const { state: authState, dispatch: authDispatch } = React.useContext(AuthContext);

  if (!authState.isAuthenticated) {
      console.log("Auth state failed! ");
      // console.log(authState);
      return <Navigate to={`/login?redirect=${pathname}${search}`} />;
  }

  return children;
}